export function canConfirmPageMetadataEval(args: {
  generatedValuesAreEmpty: boolean
  formValuesAreEmpty: boolean
  shouldHaveMetadata: boolean | undefined
}): boolean {
  if (!args.generatedValuesAreEmpty) return true
  if (args.shouldHaveMetadata === undefined) return false
  if (args.shouldHaveMetadata && args.formValuesAreEmpty) return false
  return true
}
